/**
 * Teals Design System - Color Tokens
 *
 * Default palette aligned with teals-website (assets/css/tealslabs.css).
 * Use these tokens for consistency with the marketing site.
 * @see teals-website/assets/css/tealslabs.css
 */
export const colors = {
    // Brand Colors - from teals-website --teal-* (TealsClub palette)
    primary: {
        50: '#e8f7f6', // --teal-50
        100: '#d1efed', // --teal-100
        200: '#a3dfdb', // --teal-200
        300: '#4eb8ad', // --teal-light
        400: '#2d9a8f', // main (--teal-primary) alias
        500: '#2d9a8f', // --teal-primary (main primary color)
        600: '#1a7a70', // --teal-dark
        700: '#1a7a70', // alias
        800: '#0f5c55', // --teal-darker
        900: '#0f5c55', // alias
    },
    // Secondary/Accent - from teals-website --accent-orange
    secondary: {
        50: '#fff7ed',
        100: '#ffedd5',
        200: '#fed7aa',
        300: '#fb923c', // --accent-orange-light
        400: '#f97316', // --accent-orange (main)
        500: '#f97316', // --accent-orange
        600: '#ea580c', // --accent-orange-dark
        700: '#c2410c',
        800: '#9a3412',
        900: '#7c2d12',
    },
    // Navy - from teals-website --navy-* (headers, dark UI)
    navy: {
        600: '#3d4f6a', // --navy-600
        700: '#2c3a52', // --navy-700
        800: '#232f42', // --navy-800
        900: '#1a2332', // --navy-900
    },
    // Neutral/Gray - from teals-website --slate-*
    neutral: {
        0: '#ffffff', // --white
        50: '#f8fafc', // --slate-50
        100: '#f1f5f9', // --slate-100
        200: '#e2e8f0', // --slate-200
        300: '#cbd5e1', // --slate-300
        400: '#94a3b8', // --slate-400
        500: '#64748b', // --slate-500
        600: '#475569', // --slate-600
        700: '#334155', // --slate-700
        800: '#1e293b', // --slate-800
        900: '#0f172a', // --slate-900
        1000: '#000000',
    },
    // Semantic Colors
    success: {
        light: '#81C784',
        main: '#4CAF50',
        dark: '#388E3C',
        contrastText: '#FFFFFF',
    },
    warning: {
        light: '#FFB74D',
        main: '#FF9800',
        dark: '#F57C00',
        contrastText: '#000000',
    },
    error: {
        light: '#E57373',
        main: '#F44336',
        dark: '#D32F2F',
        contrastText: '#FFFFFF',
    },
    info: {
        light: '#64B5F6',
        main: '#2196F3',
        dark: '#1976D2',
        contrastText: '#FFFFFF',
    },
    // Background Colors
    background: {
        default: '#FFFFFF',
        paper: '#f8fafc', // slate-50
        elevated: '#FFFFFF',
    },
    // Text Colors - aligned with slate scale
    text: {
        primary: '#334155', // slate-700
        secondary: '#475569', // slate-600
        disabled: '#94a3b8', // slate-400
        hint: '#64748b', // slate-500
        inverse: '#FFFFFF',
    },
    // Border Colors - from teals-website --border-*
    border: {
        light: '#e5e7eb', // --border-light
        main: '#d1d5db', // --border-medium
        dark: '#9e9e9e',
    },
};
